exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_object-gops.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_object-gops.js
// module chunks = 6